// Download an output file built in the data worker, with a busy flag for the
// button (large Excel files take a few seconds; the UI stays responsive).
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { downloadOutput } from "./dataHost";

export const useDownload = () => {
  const [busy, setBusy] = useState(false);
  const download = useCallback(async (scope, output) => {
    setBusy(true);
    try {
      await downloadOutput(scope, output);
    } catch (error) {
      toast.error(`Could not build the file: ${error.message}`);
    } finally {
      setBusy(false);
    }
  }, []);
  return [busy, download];
};
